import React from 'react';
import PropTypes from 'prop-types';
import { usePickContext } from '../../PickProvider';
import Parcel from '../../../../../components/Parcel';
import { getTotalQuantityInOtherParcels } from '../../utils';

const PickItemParcels = ({ item, itemQuantity }) => {
  const {
    handleSaveCurrentItem,
    currentParcel,
    setCurrentParcel,
    parcels,
    setParcels,
    shipment,
    setShowParcelsDialog,
    showParcelsDialog,
  } = usePickContext();
  const parcelQuantities = parcels.reduce((acc, parcel) => {
    const itemParcel = item?.parcels?.[parcel.id];
    let quantity = itemParcel?.item_ids?.length ?? 0;

    if (parcel.id === currentParcel?.id) {
      const quantityInOtherParcels = getTotalQuantityInOtherParcels(item, currentParcel);
      quantity = itemQuantity - quantityInOtherParcels;
    }

    return {
      ...acc,
      [parcel.id]: quantity,
    };
  }, {});

  const handleCreateParcel = parcel => {
    setParcels(currentParcels => [...currentParcels, parcel]);
    setCurrentParcel(parcel);
  };

  const handleSelectParcel = parcel => {
    setCurrentParcel(parcel);
  };

  const handleCloseParcelDialog = () => {
    setShowParcelsDialog(false);
  };

  return (
    <Parcel
      currentParcel={currentParcel}
      isOpen={showParcelsDialog}
      parcels={parcels}
      parcelQuantities={parcelQuantities}
      onBeforeCreate={async () => handleSaveCurrentItem(true)}
      onBeforeSelect={async () => handleSaveCurrentItem(true)}
      onClose={handleCloseParcelDialog}
      onCreate={handleCreateParcel}
      onSelect={handleSelectParcel}
      shipmentId={shipment?.id}
    />
  );
};

PickItemParcels.propTypes = {
  item: PropTypes.object.isRequired,
  itemQuantity: PropTypes.number,
};

PickItemParcels.defaultProps = {
  itemQuantity: 0,
};

export default PickItemParcels;
